

















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ActorLabelUsage extends Vue {
  @Prop() title!: string;
  @Prop() icon!: string;
}
